import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Payroll, PayrollCreate, PayrollFilter } from '../data/payroll';

export function createPayrollService(client: AxiosInstance) {
  return createCrudService<Payroll, PayrollCreate, PayrollFilter>(client, '/Payroll', 'payrollId');
}

export type PayrollService = CrudService<Payroll, PayrollCreate, PayrollFilter>;
